/*
* Progress bar script
*/
class ST_ProgressBar {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.progressBar = $('.progress-bar');
        this.article = $('.single-article');
        this.winHeight = this.win.height();
        this.docHeight = $(document).height();
        this.max = this.docHeight - this.winHeight;
        this.value = this.win.scrollTop();

        this.progressBar.attr('max', this.max);
        this.progressBar.attr('value', this.value);
    }

    initEvents() {
        if (this.progressBar.length) {
            $(document).on('scroll', () => {
                this.value = this.win.scrollTop();
                this.progressBar.attr('value', this.value);
            });
        }
    }
}